export interface Report {
  reportId: string;
  fileId: string;
  status: ExportStatusEnum;
  updatedDate: string;
}

export interface Page {
  limit: number;
  offset: number;
  totalPages: number;
  totalElements: number;
}

export interface ReportsResponse {
  reports: Report[];
  page: Page;
}

export interface ExportStatus {
  reportId?: string;
  status?: ExportStatusEnum;
  updatedDate?: string;
}

export enum ExportStatusEnum {
  PROCESSING = 'PROCESSING',
  REPORT_GENERATED = 'REPORT_GENERATED',
  DOWNLOADED = 'DOWNLOADED',
  FAILED = 'FAILED'                    
}

export interface ExportButtonState {
  buttonState: ExportButtonStateEnum;
  disabled: boolean;
  reportId?: string;
}

export enum ExportButtonStateEnum {
  REQUEST_EXPORT = 'REQUEST_EXPORT',
  IN_PROCESSING = 'IN_PROCESSING',
  DOWNLOAD_READY = 'DOWNLOAD_READY'
}
